<template>
  <v-card class="elevation-1 pa-3">
    <v-form @submit.prevent="login">
      <v-card-text>
        <v-alert v-if="formError" type="error">{{ formError }}</v-alert>

        <v-row v-if="withPhoneCode">
          <v-col
            cols="12"
            sm="4">
            <v-select
              v-model="code"
              :items="codes"
              label="Код"
              single-line
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="8">
            <v-text-field
              v-if="code"
              label="Телефон"
              v-model="phone"
              v-mask="phoneMaskByCode"
              :disabled="loading"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-text-field
          v-else
          label="Телефон"
          v-model="user.phone"
          v-mask="phoneMask"
          :disabled="loading"
          required
        />
        <v-text-field
          label="Пароль"
          :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="() => (showPass = !showPass)"
          :type="showPass ? 'text' : 'password'"
          v-model="user.password"
          :disabled="loading"
          required
        />
      </v-card-text>
      <v-card-text style="display: flex; padding-top: 0;">
        <router-link :to="{ name: 'login.forgot'}">Забыли пароль?</router-link>
        <v-spacer></v-spacer>
        <v-btn type="submit" color="primary" :loading="loading">Войти</v-btn>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import _ from 'lodash';
import { mask } from 'vue-the-mask';
/* mixins */
import phoneMixin from '@/mixins/phoneMixin';

export default {
  name: 'LoginIndex',
  directives: { mask },
  components: {},
  mixins: [phoneMixin],
  data() {
    return {
      loading: false,
      phoneMask: '+380 (##) ###-##-##',
      phoneMaskByCode: ' (##) ###-##-##',
      code: '+420',
      codes: ['+380', '+420'],
      phone: '',
      user: {
        phone: '',
        password: '',
      },
      errors: [],
      showPass: false,
    };
  },
  computed: {
    formError() {
      if (!_.isEmpty(this.errors)) {
        const errors = this.errors[Object.keys(this.errors)[0]];
        return errors[0];
      }

      return null;
    },
  },
  methods: {
    login() {
      this.loading = true;
      if (this.withPhoneCode) {
        this.user.phone = this.code + this.phone;
      }
      this.$store.dispatch('auth/login', this.user)
        .catch(response => {
          if (response) {
            this.errors = [];
            switch (response.status) {
              case 422:
                if (_.isEmpty(response.data.data)) {
                  this.error = response.data.message;
                  this.$store.dispatch('page/displaySnackbar', {
                    text: response.data.message,
                    color: 'red darken-3',
                    timeout: 6000,
                  });
                }
                this.errors = response.data.data;
                break;
              default:
                // eslint-disable-next-line no-case-declarations
                let message = response.statusText;
                if (response.data.message) {
                  // eslint-disable-next-line prefer-destructuring
                  message = response.data.message;
                }
                this.$store.dispatch('page/displaySnackbar', {
                  text: message,
                  color: 'red darken-3',
                  timeout: 6000,
                });
                console.error(response);
                break;
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
